import React, { useState } from 'react';
import './Collapsible.css';

// Generic expand/collapse section used by the Excellence Program week
// panel (Theory / Examples / Try Yourself, and Theory's own per-topic
// sub-sections) so a week's full content isn't all visible at once.
function Collapsible({ title, badge, defaultOpen = false, nested = false, children }) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`collapsible ${nested ? 'collapsible-nested' : ''} ${open ? 'collapsible-open' : ''}`}>
      <button type="button" className="collapsible-header" onClick={() => setOpen((o) => !o)}>
        <svg className="collapsible-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="m9 6 6 6-6 6" />
        </svg>
        <span className="collapsible-title">{title}</span>
        {badge != null && <span className="collapsible-badge">{badge}</span>}
      </button>
      {open && <div className="collapsible-body">{children}</div>}
    </div>
  );
}

export default Collapsible;
